import axios from 'axios';

export default function getActiveNotifyUsers(params) {
    return axios.get('https://admin-notifier.hirist.com/notify/active-users')
}
